export enum TargetType {
  Product = 0,
  Category = 1,
  Customer = 2,
  Vendor = 3,
  CartItem = 5
}

export interface CouponTarget {
  targetType: TargetType;
  targetIds: number[];
}

// List item interface (from /AdminPanel/GetCouponList)
export interface CouponItem {
  id: number;
  name: string;
  code: string;
  expirationDate: string | null;
}

// Full entity interface (from /AdminPanel/GetCouponDetails)
export interface CouponEntity {
  id: number;
  name: string;
  code: string;
  expirationDate: string;
  type: number; // 0: Fixed, 1: Percent
  discountAmount?: number;
  shippingDiscountAmount?: number | null;
  usageLimitation?: number | null;
  applyOnDiscountedProducts?: boolean;
  targets: CouponTarget[];
}

export interface CouponCreate {
  fields: Omit<CouponEntity, 'id'>;
}

export interface CouponUpdate {
  couponId: number;
  fields: Partial<Omit<CouponEntity, 'id'>>;
}
